<div class="dialog-padding">
  <h3 class="title" id="selectProviderDialog-heading-selectProvider" mat-dialog-title>Select Provider</h3>
  <div mat-dialog-content>
    <h1 id="selectProviderDialog-heading-rideOn">
      Ride on {{ data.rideRequest.formattedItineraryDate }} at
      <strong>{{ data.rideRequest.formattedPickupTime }}</strong>
    </h1>

    <!-- Has Expressed Interest -->
    <ng-container *ngIf="interestedProviders.length > 0">
      <div id="selectProviderDialog-section-interestedProviders" class="interest-list">
        <h3 class="dividing-header">Expressed Interest</h3>
        <app-select-provider-list-item
          *ngFor="let providerSelectionDetail of interestedProviders"
          [providerSelectionDetail]="providerSelectionDetail"
          [pickupTime]="data.rideRequest.formattedPickupTime"
          (providerSelected)="handleProviderSelected(providerSelectionDetail)"
        >
        </app-select-provider-list-item>
      </div>
    </ng-container>

    <!-- Has Proposed New Time -->
    <ng-container *ngIf="providersProposingNewTime.length > 0">
      <div id="selectProviderDialog-section-proposedTimes" class="interest-list">
        <mat-divider *ngIf="interestedProviders.length > 0"></mat-divider>
        <h3 class="dividing-header">Proposed New Time</h3>
        <app-select-provider-list-item
          *ngFor="let providerSelectionDetail of providersProposingNewTime"
          [providerSelectionDetail]="providerSelectionDetail"
          [pickupTime]="data.rideRequest.formattedPickupTime"
          [timeZone]="data.rideRequest.timeZone"
          (providerSelected)="handleProviderSelected(providerSelectionDetail)"
        >
        </app-select-provider-list-item>
      </div>
    </ng-container>

    <!-- No Providers Expressed Interest -->
    <ng-container *ngIf="interestedProviders.length === 0 && providersProposingNewTime.length === 0">
      <div id="selectProviderDialog-section-noInterestedProviders" class="interest-list">
        <h3 class="dividing-header">Expressed Interest</h3>
        No providers have expressed interest yet.
      </div>
    </ng-container>

    <!-- Toggle to Show/Hide Other Providers -->
    <ng-container *ngIf="providersHaveNotExpressedInterest.length > 0 || providersIgnoringRideRequest.length > 0">
      <div id="selectProviderDialog-section-otherProvidersToggle" class="interest-list">
        <mat-divider class="dividing-header"></mat-divider>
        <button id="selectProviderDialog-button-toggleShowProviders" mat-button (click)="toggleOtherProviders()">
          {{ getOtherProvidersButtonText() }}
        </button>
      </div>
    </ng-container>

    <ng-container *ngIf="isShowingOtherProviders">
      <!-- Has Not Expressed Interest -->
      <div
        *ngIf="providersHaveNotExpressedInterest.length > 0"
        id="selectProviderDialog-section-haveNotExpressedInterest"
        class="interest-list"
      >
        <h3 class="dividing-header">Have Not Expressed Interest</h3>
        <app-select-provider-list-item
          *ngFor="let providerSelectionDetail of providersHaveNotExpressedInterest"
          id="selectProviderDialog-listItem-providerHasNotExpressedInterest-{{ providerSelectionDetail.id }}"
          [providerSelectionDetail]="providerSelectionDetail"
          [pickupTime]="data.rideRequest.formattedPickupTime"
          [timeZone]="data.rideRequest.timeZone"
          (providerSelected)="handleProviderSelected(providerSelectionDetail)"
        >
        </app-select-provider-list-item>
      </div>

      <!-- Ignored -->
      <div *ngIf="providersIgnoringRideRequest.length > 0" id="selectProviderDialog-section-providersIgnoringRide" class="interest-list">
        <mat-divider></mat-divider>
        <h3 class="dividing-header">Ignored</h3>
        <app-select-provider-list-item
          *ngFor="let providerSelectionDetail of providersIgnoringRideRequest"
          id="selectProviderDialog-listItem-ignoringProvider-{{ providerSelectionDetail.id }}"
          [providerSelectionDetail]="providerSelectionDetail"
          [pickupTime]="data.rideRequest.formattedPickupTime"
          [timeZone]="data.rideRequest.timeZone"
          (providerSelected)="handleProviderSelected(providerSelectionDetail)"
        >
        </app-select-provider-list-item>
      </div>
    </ng-container>

    <div mat-dialog-actions align="end">
      <button id="selectProviderDialog-button-close" type="button" mat-button data-dismiss="modal" (click)="close()">Close</button>
    </div>
  </div>
</div>
